import { RootState } from 'app/store/rootReducer';

export const selectAcquisitionParams = (state: RootState) =>
  state.acquisition.acquisitionParams;

export const getRenewalQuotation = (state: RootState) =>
  state.acquisition.isRenewalQuotation;
